// src/componentForms/templates/contactForm/SingleColumnContactForm.jsx
import React from 'react';
import { Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { API_URL } from '../../../../../config';
import { useAppData } from '../../../AppDataContext';

const SingleColumnContactForm = ({
  formFields,
  formName,
  buttonText,
  styles,
  onSubmit,
  validationMessages,
  successMessage,
  // ✅ NEW
  componentId,
  subcomponentId,
}) => {
  const { subdomain } = useAppData();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fieldData = {};
    const errors = [];

    formFields.forEach((field) => {
      const value = e.target[field.name]?.value ?? '';
      fieldData[field.name] = value;

      if (field.required && (!value || value.trim() === '')) {
        const msg = validationMessages?.required
          ? validationMessages.required.replace('$field', field.label || field.name)
          : `${field.label || field.name} is required.`;
        errors.push(msg);
      } else if (value) {
        if (field.type === 'email') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            const msg = validationMessages?.email
              ? validationMessages.email.replace('$field', field.label || field.name)
              : `${field.label || field.name} must be a valid email address.`;
            errors.push(msg);
          }
        }
        if (field.type === 'number' && isNaN(Number(value))) {
          const msg = validationMessages?.number
            ? validationMessages.number.replace('$field', field.label || field.name)
            : `${field.label || field.name} must be a valid number.`;
          errors.push(msg);
        }
      }
    });

    if (errors.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        html: errors.join('<br/>'),
        icon: 'error',
      });
      return;
    }

    const finalFormName = formName || 'Contact Form';

    const payload = {
      data: fieldData,
      form_name: finalFormName,
      // ✅ include IDs
      component_id: componentId ?? null,
      subcomponent_id: subcomponentId ?? null,
    };

    try {
      const response = await fetch(`${API_URL}/contact-submissions?account_key=${subdomain}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to submit form');
      }
      const result = await response.json();
      Swal.fire({
        title: 'Success',
        text: successMessage || 'Form submitted successfully!',
        icon: 'success',
      });
      e.target.reset();
      onSubmit && onSubmit(result);
    } catch (error) {
      Swal.fire({
        title: 'Submission Error',
        text: error.message || 'There was an error submitting the form.',
        icon: 'error',
      });
    }
  };

  return (
    <Form onSubmit={handleSubmit} style={styles.container}>
      {formFields.map((field, index) => {
        const controlProps = field.type === 'textarea' ? { as: 'textarea' } : { type: field.type || 'text' };
        return (
          <Form.Group key={index} className="s-contact-form-wrapper" controlId={`form_${field.name}`}>
            <Form.Label style={styles.labels}>{field.label}</Form.Label>
            <Form.Control name={field.name} placeholder={field.placeholder} style={styles.inputs} {...controlProps} />
          </Form.Group>
        );
      })}
      <Button variant="primary" className="s-contact-btn" type="submit" style={styles.button}>
        {buttonText || 'Submit'}
      </Button>
    </Form>
  );
};

export default SingleColumnContactForm;
